import { useSelector } from "react-redux";
import { StateExtended } from "../../_config/interfaces/stateExtended";

export const useAuthStatus = () => useSelector((state: StateExtended) => state.user.isAuthenticated);
export const useUserSelector = () => useSelector((state: StateExtended) => state.user.user);
export const useIsForgotPassword = () => useSelector((state: StateExtended) => state.user.user?.isForgotPassword === true);
export const useUserListSelector = () => useSelector((state: StateExtended) => state.userManagement.users);
export const useMenusSelector = () => useSelector((state: StateExtended) => state.user.menus);
export const useMenuPermissionsSelector = () => useSelector((state: StateExtended) => state.user.menuPermissions);

export const useIsOwnerAdmin = () => useSelector((state: StateExtended) => state.user.user?.isOwnerAdmin === true);
// `undefined` means the persisted session predates the consent release (login response carried no flag).
export const useTermAcceptedFlag = () => useSelector((state: StateExtended): boolean | undefined => state.user.user?.isTermAccepted);
// `undefined` means the persisted session predates the flag; resolve it via RolePermission/Detail.
export const useOwnerAdminFlag = () => useSelector((state: StateExtended): boolean | undefined => state.user.user?.isOwnerAdmin);
